import logo from "./logo.svg";
import "./App.css";
import React, { useState, useContext } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Home from "./components/Home";
import Realization from "./components/Realization";
import Operations from "./components/Operations";
import OperationsHistory from "./components/OperationsHistory";
import PrintLabel from "./components/PrintLabel";

const App = () => {
  return (
    <div>
      <Router>
        <Switch>
          <Route exact path="/" component={Home} />
          <Route exact path="/:workerCode/" component={Home} />
          <Route
            path="/realization/:id/:actionId/:worker/"
            component={Realization}
          />
          <Route path="/operations/:id/:worker/" component={Operations} />
          <Route
            path="/operationshistory/:worker/"
            component={OperationsHistory}
          />
          <Route
            path="/printlabel/:id/:actionId/:worker/"
            component={PrintLabel}
          />
        </Switch>
      </Router>
    </div>
  );
};

export default App;
